import Auth from "@/features/Auth/components/Auth/Auth";
import { RoutesObjectInterface } from "../router.types";

const publicRoutes: RoutesObjectInterface[] = [
  {
    path: '/',
    element: <Auth/>
  }
]

export default publicRoutes;